import {
  AdjustmentsVerticalIcon,
  BuildingLibraryIcon,
  BuildingOfficeIcon,
  ChartBarIcon,
  CircleStackIcon,
  ClipboardDocumentListIcon,
  HomeIcon,
  MagnifyingGlassCircleIcon,
  PresentationChartLineIcon,
} from '@heroicons/react/24/outline';
import type { NavItemInterface } from '../SidebarNav';

export const navItemObjects: NavItemInterface[] = [
  {
    name: 'My Company',
    path: '/terminal/company',
    icon: BuildingLibraryIcon,
    permissions: ['VIEW_COMPANY_DASHBOARD'],
  },
  {
    name: 'My Dashboard',
    path: '/terminal/dashboard',
    icon: HomeIcon,
    subMenu: [
      { name: 'My Tasks', path: '/tasks' },
      {
        name: 'My Deliverables',
        path: '/deliverables',
      },
      {
        name: 'My Milestones',
        path: '/milestones',
      },
      {
        name: 'My Approvals',
        permissions: ['LIST_APPROVALS'],
        path: '/approvals',
      },
    ],
  },
  {
    name: 'Rover',
    path: '/terminal/rover',
    icon: PresentationChartLineIcon,
    subscription: 'ROVER',
    permissions: ['LIST_PARTNER_PROPOSALS', 'LIST_CLIENT_APPLICATIONS', 'LIST_APPLICATION_FORMS'],
    subMenu: [
      {
        name: 'Application Forms',
        path: '/application_forms',
        permissions: ['LIST_APPLICATION_FORMS'],
      },
    ],
    // subMenu: [
    //   {
    //     name: "Client Applications",
    //     path: "/client-applications",
    //     permissions: ["LIST_CLIENT_APPLICATIONS"],
    //   },
    //   {
    //     name: "Partner Proposals",
    //     path: "/partner-proposals",
    //     permissions: ["LIST_PARTNER_PROPOSALS"],
    //   },
    //   {
    //     name: "Application Forms",
    //     path: "/application_forms",
    //     permissions: ["LIST_APPLICATION_FORMS"],
    //   },
    //   {
    //     name: 'FBDI',
    //     path: '/fbdi',
    //     permissions: ['LIST_PARTNER_PROPOSALS'],
    //   },
    // ],
  },
  {
    name: 'Lottery Management',
    path: '/terminal/lottery',
    icon: CircleStackIcon,
    subMenu: [
      {
        name: 'Lotteries',
        path: '',
        // permissions: [],
      },
    ],
  },
  {
    name: 'Sherpa',
    path: '/terminal/sherpa',
    subscription: 'SHERPA',
    icon: BuildingOfficeIcon,
    permissions: ['LIST_PROJECTS', 'LIST_ALL_PROJECTS', 'VIEW_SHERPA_DASHBOARD'],
    subMenu: [
      {
        name: 'Dashboard',
        path: '/dashboard',
        permissions: ['VIEW_SHERPA_DASHBOARD'],
      },
      {
        name: 'Projects',
        path: '/projects',
        permissions: ['LIST_PROJECTS', 'LIST_ALL_PROJECTS'],
      },
      {
        name: 'Project Templates',
        path: '/project-templates',
        permissions: ['LIST_PROJECT_TEMPLATES'],
      },
    ],
  },
  {
    name: 'Vendor Management',
    path: '/terminal/vendor',
    icon: MagnifyingGlassCircleIcon,
    permissions: ['LIST_VENDORS'],
  },
  {
    name: 'Administration',
    path: '/terminal/administration',
    icon: AdjustmentsVerticalIcon,
    permissions: ['LIST_USERS', 'LIST_TITLES', 'LIST_CATEGORIES', 'READ_ROLE'],
    subMenu: [
      {
        name: 'User Management',
        path: '/users',
        permissions: ['LIST_USERS'],
      },
      {
        name: 'Organizational Titles',
        path: '/organizational-titles',
        permissions: ['LIST_TITLES'],
      },
      {
        name: 'Management of Roles & Privileges',
        path: '/roles-and-permissions',
        permissions: ['READ_ROLE'],
      },
      {
        name: 'Category Management',
        path: '/category-management',
        permissions: ['LIST_CATEGORIES'],
      },
    ],
  },
];

export const sageAdminNavItemObjects: NavItemInterface[] = [
  {
    name: 'Clients',
    path: '/os/clients',
    icon: ClipboardDocumentListIcon,
    permissions: ['LIST_CLIENTS'],
  },
  {
    name: 'Sales & Marketing',
    path: '/os/sales-marketting',
    icon: ChartBarIcon,
    subMenu: [
      {
        name: 'Sales',
        path: '/sales',
      },
      {
        name: 'Government Intake',
        path: '/government-intake',
      },
    ],
  },
  {
    name: 'Administration',
    path: '/os/administration',
    icon: AdjustmentsVerticalIcon,
    permissions: ['LIST_USERS', 'LIST_TITLES', 'READ_ROLE'],
    subMenu: [
      { name: 'Users', path: '/users', permissions: ['LIST_USERS'] },
      {
        name: 'Organizational Titles',
        path: '/organizational-titles',
        permissions: ['LIST_TITLES'],
      },
      {
        name: 'Roles and Permission',
        path: '/roles-and-permissions',
        permissions: ['READ_ROLE'],
      },
      {
        name: 'Widgets Management',
        path: '/widgets-management',
        permissions: ['MANAGE_COMPANY_WIDGETS'],
      },
    ],
  },
];
